const SESSION_KEY = "metacard-web-session";

export function getWebSession() {
  try {
    const session = JSON.parse(localStorage.getItem(SESSION_KEY) || "null");
    if (session?.credential?.startsWith("web-session:") && session.expiresAt * 1000 > Date.now()) return session;
    localStorage.removeItem(SESSION_KEY);
  } catch {
    try { localStorage.removeItem(SESSION_KEY); } catch { /* Storage can be disabled by the browser. */ }
  }
  return null;
}

export function getAuthData() {
  const telegramData = window.Telegram?.WebApp?.initData || "";
  const session = getWebSession();
  // A saved browser account must not override a new Telegram launch.
  // This context is saved only when a code login replaces failed Telegram auth.
  const telegramContext = new URLSearchParams(telegramData).get("hash") || "";
  if (telegramData && session?.telegramContext !== telegramContext) return telegramData;
  return session?.credential || telegramData;
}

export function getAuthUserId() {
  if (getAuthData().startsWith("web-session:")) return getWebSession()?.userId || "guest";
  return window.Telegram?.WebApp?.initDataUnsafe?.user?.id || "guest";
}

export function saveWebSession(session) {
  const telegramData = window.Telegram?.WebApp?.initData || "";
  localStorage.setItem(SESSION_KEY, JSON.stringify({
    ...session,
    telegramContext: telegramData ? new URLSearchParams(telegramData).get("hash") || "" : null,
  }));
}

export function clearWebSession() {
  localStorage.removeItem(SESSION_KEY);
}
